const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const pct = (b) => ({ left: `${b.x * 100}%`, top: `${b.y * 100}%`, width: `${b.w * 100}%`, height: `${b.h * 100}%` });

export default function TamperOverlay({ claimId, pageNo, baseSrc, fraudPage, alerts }) {
  const pageAlerts = (alerts || []).filter(a => a.page_no === pageNo);
  const boxed = pageAlerts.filter(a => a.bounding_box && typeof a.bounding_box.x === "number");
  const hotspots = fraudPage?.ela?.heat_bbox ? [{ bbox: fraudPage.ela.heat_bbox, ratio: fraudPage.ela.hot_fraction || 0 }] : [];
  const cmRegions = (pageAlerts.some(a => a.alert_code === "IMG-03") && fraudPage?.copy_move?.regions) || [];
  const src = fraudPage?.tamper_heatmap_path ? `${API}/fraud/document/${claimId}/heatmap/${pageNo}` : baseSrc;

  return (
    <div className="relative inline-block max-w-full" data-testid={`tamper-overlay-${pageNo}`}>
      <img src={src} alt={`Page ${pageNo} tamper heatmap`} className="max-w-full shadow-lg rounded border border-orange-400" data-testid={`heatmap-page-image-${pageNo}`} />
      {hotspots.map((h, i) => (
        <div key={`h-${i}`} className="absolute border-2 border-orange-500 bg-orange-400/10 pointer-events-none" style={pct(h.bbox)} data-testid={`overlay-hotspot-${i}`}>
          <span className="absolute -top-4 left-0 text-[9px] font-bold bg-orange-500 text-white px-1 rounded-sm">ELA {fraudPage?.ela?.hot_blocks || 0} blocks</span>
        </div>
      ))}
      {cmRegions.map((r, i) => (
        <div key={`c-${i}`} className="absolute border-2 border-dashed border-purple-500 pointer-events-none" style={pct(r)} data-testid={`overlay-copymove-${i}`}>
          <span className="absolute -top-4 left-0 text-[9px] font-bold bg-purple-600 text-white px-1 rounded-sm">COPY-MOVE {i === 0 ? "SRC" : "DST"}</span>
        </div>
      ))}
      {boxed.map((a, i) => (
        <div key={a.alert_id} className="absolute border-2 border-red-600 bg-red-500/10 pointer-events-none" style={pct(a.bounding_box)} data-testid={`overlay-alert-${a.alert_code}`}>
          <span className="absolute -top-4 left-0 text-[9px] font-bold bg-red-600 text-white px-1 rounded-sm whitespace-nowrap">{a.alert_code}{a.field_name ? ` · ${a.field_name}` : ""}</span>
        </div>
      ))}
      <div className="absolute bottom-2 left-2 bg-white/90 border border-gray-300 rounded px-2 py-1 text-[10px] text-gray-700 flex gap-3 shadow" data-testid="overlay-legend">
        <span><span className="inline-block w-2.5 h-2.5 bg-red-600 rounded-sm mr-1 align-middle" />{pageAlerts.length} alert{pageAlerts.length === 1 ? "" : "s"}</span>
        <span><span className="inline-block w-2.5 h-2.5 bg-orange-500 rounded-sm mr-1 align-middle" />{hotspots.length} ELA</span>
        <span><span className="inline-block w-2.5 h-2.5 bg-purple-600 rounded-sm mr-1 align-middle" />{cmRegions.length ? "copy-move" : "no copy-move"}</span>
      </div>
    </div>
  );
}
